var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.price)?[_vm._v("\n        "+_vm._s(_vm.price.name)+" : "),_c('strong',[_vm._v(_vm._s(_vm.price.formatted_amount))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }